<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    桃源村站<br>
站点介绍<br>
桃源村站位于龙珠大道与龙珠六路及龙珠七路交汇处路段之间，车站主体位于龙珠大道路面下，沿龙珠大道布置。车站北侧是深圳市水质监测中心、郁金香家园及俊峰丽舍小区。南侧为桃源村小区。周边小区及楼房都为成熟小区，人流量较大。从规划用地来看，周围也多为居住用地及办公用地，该站客流主要为周边居民。桃源村站装修以米白色及橙红色为主色调，柱面采用搪瓷钢板，现场美观大方，经济适用，以LED倒三角造型灯具设计特色展示出"中国梦--缤纷生活梦"的总体文化特征。本站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:11	23:46	7号线	3分35秒	5分55秒<br>
太安	06:26	23:11	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:17	23:46	7号线	4分钟	5分55秒<br>
太安	06:31	23:11	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:17	00:46	7号线	4分钟	5分55秒<br>
太安	06:31	00:11	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
龙珠大道南侧、桃源村、桃源中学、龙珠六路<br><br>
B出入口:<br>
龙珠大道南侧、桃源村、卓雅小学、桃苑实验学校、桃源村三期、岁宝百货、盒马超市<br><br>
C出入口:<br>
香榭峰景苑、龙珠七路、龙珠大道北侧、天地峰景园、中爱花园、俊峰丽舍、龙福苑、深圳市养老护理院、梅州大厦、深圳南山国际学校<br><br>
D出入口:<br>
龙珠大道北侧、郁金香家园、皇庭香格里花园、水木华庭、湖彬苑、桃园社区公园、龙珠中学、龙珠六路、十五峰、塘朗山公园、深圳水务集团水质监测站<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 桃源村<br>
41路,58路,67路,104路,201路,235路,316路,325路,326路,334路,B707路,M203路,M369路,高峰专线69路,高峰专线49路,高峰专线62路<br><br>
B出入口:<br>
公交站名： 桃源村东<br>
104路,201路,235路,240路,25路,316路,325路,326路,334路,41路,58路,67路,B706路,B707路,M203路,M369路,高峰专线49路,高峰专线62路<br><br>
C出入口:<br>
公交站名： 桃源村东<br>
104路,201路,235路,240路,316路,325路,326路,334路,41路,58路,67路,B706路,M203路,M369路,高峰专线49路,高峰专线62路<br><br>
D出入口:<br>
公交站名： 桃源村<br>
41路,58路,67路,104路,201路,235路,316路,325路,326路,334路,B707路,M203路,M369路,高峰专线69路,高峰专线49路,高峰专线62路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>